import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  topOuterDivider: PropTypes.bool,
  topDivider: PropTypes.bool
}

const defaultProps = {
  topOuterDivider: false,
  topDivider: false
}

const Footer = ({
  className,
  topOuterDivider,
  topDivider,
  ...props
}) => {

  const classes = classNames(
    'site-footer center-content-mobile',
    topOuterDivider && 'has-top-divider',
    className
  );

  return (
    <footer
      {...props}
      className={classes}
    >
      <hr style={{color:"white",height:"2px", marginTop:"40px"}}></hr>
      <div className="container">
        <div 
        style={{marginBottom: '40px'}}
        className={
          classNames(
            // 'site-footer-inner',
            topDivider && 'has-top-divider'
          )}>
          <div style={{textAlign:"center"}} className="footer-bottom center text-xxs invert-order-desktop">
            <div className="text-center mt-12" >© <a target="_blank" rel="noopener noreferrer" href="http://rapidmindpower.in/">Rapid Mind Power</a>{" "}{new Date().getFullYear()}</div>
            <div className="text-center mt-12" >Developed by <a target="_blank" rel="noopener noreferrer" href="https://iotreeminds.com/">iotree minds</a></div>
            <div className="text-center mt-12" >All rights reserved by Rapid Mind Power Consultancy</div>
          </div>
        </div>
      </div>
    </footer>
  );
}

Footer.propTypes = propTypes;
Footer.defaultProps = defaultProps;

export default Footer;